import * as React from "react";

const SvgComponent = (props) => (
  <svg
    viewBox="0 0 18 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <mask id="a" fill="#fff">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.804 1.063c-.51.11-.582.785-.153 1.082.601.416 1.173.892 1.708 1.427 4.807 4.807 4.807 12.6 0 17.406a12.285 12.285 0 0 1-3.484 2.448c-.473.22-.515.899-.03 1.092 4.433 1.774 9.69.866 13.281-2.725 4.807-4.806 4.807-12.6 0-17.406A12.298 12.298 0 0 0 2.804 1.063Z"
      />
    </mask>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.804 1.063c-.51.11-.582.785-.153 1.082.601.416 1.173.892 1.708 1.427 4.807 4.807 4.807 12.6 0 17.406a12.285 12.285 0 0 1-3.484 2.448c-.473.22-.515.899-.03 1.092 4.433 1.774 9.69.866 13.281-2.725 4.807-4.806 4.807-12.6 0-17.406A12.298 12.298 0 0 0 2.804 1.063Z"
      fill="#ffe03c"
    />
    <path
      d="m.875 23.426-.848-1.812.848 1.812ZM2.65 2.146 1.513 3.79 2.65 2.145Zm.153-1.083L2.38-.892l.424 1.955ZM1.513 3.79c.502.348.982.746 1.432 1.196l2.829-2.828A14.38 14.38 0 0 0 3.789.5L1.513 3.79Zm1.432 1.196c4.026 4.026 4.026 10.552 0 14.578l2.829 2.828c5.587-5.587 5.587-14.647 0-20.234L2.945 4.986Zm0 14.578a10.287 10.287 0 0 1-2.918 2.05l1.695 3.623a14.286 14.286 0 0 0 4.052-2.845l-2.829-2.828Zm9.767.815a10.311 10.311 0 0 1-11.124 2.282L.102 26.375c5.15 2.06 11.262 1.009 15.438-3.168l-2.828-2.828Zm0-14.578c4.026 4.026 4.026 10.553 0 14.578l2.828 2.828c5.588-5.587 5.588-14.647 0-20.234L12.712 5.8ZM3.228 3.017c3.317-.72 6.911.212 9.484 2.784l2.828-2.828A14.298 14.298 0 0 0 2.38-.892l.848 3.91Zm-3.2 18.597a2.644 2.644 0 0 0-1.525 2.287c-.04.96.474 2.024 1.599 2.474l1.486-3.714c.64.257.932.885.911 1.402-.02.477-.293.948-.777 1.174L.027 21.614ZM3.788.501c.44.304.63.814.57 1.286a1.463 1.463 0 0 1-1.131 1.23L2.38-.893C1.196-.634.513.329.392 1.282a2.645 2.645 0 0 0 1.12 2.509L3.79.5Z"
      fill="currentColor"
      mask="url(#a)"
    />
  </svg>
);

export default SvgComponent;
